import { CloseCompanyInfo } from 'ui/components/screens/modals/CloseCompanyInfo/CloseCompanyInfo';
import { useModal } from 'ui/components/screens/modals/useModal';
import { mqUser } from 'utils/responsive';
import styled from '@emotion/styled';
import Pencil from 'ui/images/icons/pencil.svg';
import { IAreaOption } from 'domain/entities/Buyer/Buyer';
import { PublicBuyerDetail } from 'ui/components/common/patterns/PublicBuyerDetail/PublicBuyerDetail';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: left;
    background-color: #f8f9fd;
`;

const Container = styled.div`
    position: relative;
    max-width: 800px;
    height: auto;
    background-color: var(--white);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    min-width: 220px;
    min-height: 330px;
    white-space: pre-wrap;
    word-break: break-all;

    ${mqUser('SP')} {
        min-width: 320px;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 30px;
`;

const EditButton = styled.button`
    background-color: var(--main-color-blue);
    color: var(--white);
    border: none;
    border-radius: 25px;
    padding: 10px 20px;
    width: fit-content;
    cursor: pointer;
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 5px;
    &:hover {
        opacity: 0.9;
    }
    &:active {
        transform: scale(0.98);
    }

    img {
        width: 15px;
    }
`;

const ClosedButton = styled.button`
    color: var(--warn);
    margin-left: 10px;
    background-color: var(--white);
    border: none;
    border-radius: 25px;
    padding: 8px 18px;
    width: fit-content;
    cursor: pointer;
    border: 3px solid var(--warn);
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 5px;
    &:hover {
        background-color: var(--warn);
        color: var(--white);
    }
    &:active {
        transform: scale(0.98);
    }
    transition: background-color 0.3s ease, color 0.3s ease;
`;

const SubtitleContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 20px 10px 0 10px;
`;

export const Preview: React.FC<{
    buyer: any;
    editing: boolean;
    setEditing?: (editing: boolean) => void;
    areaChoices: IAreaOption[];
    employeeChoices: string[][];
    revenueChoices: string[][];
    industryChoices: string[][];
    unPublish?: () => void;
    reOpen?: () => void;
    loading: boolean;
    isPublish: boolean;
}> = ({
    buyer,
    editing,
    setEditing,
    areaChoices,
    employeeChoices,
    revenueChoices,
    industryChoices,
    unPublish,
    reOpen,
    loading,
    isPublish,
}) => {
    const unPublishModal = useModal();
    const {
        openModal: openUnPublishModal,
        createModal: createUnPublishModal,
        closeModal: closeUnPublishModal,
    } = unPublishModal;

    // 選択肢データが読み込まれるまでプレビューを表示しない
    if (
        loading ||
        !areaChoices.length ||
        !employeeChoices.length ||
        !revenueChoices.length ||
        !industryChoices.length
    ) {
        return (
            <Wrapper>
                <Container>
                    <ContentWrapper />
                </Container>
            </Wrapper>
        );
    }

    return (
        <Wrapper>
            {unPublish &&
                createUnPublishModal(
                    <CloseCompanyInfo onSubmit={unPublish} onCancel={closeUnPublishModal} loading={loading} />,
                )}

            {!editing && setEditing && (
                <SubtitleContainer>
                    <EditButton onClick={() => setEditing(true)}>
                        <img src={Pencil} alt="Edit" />
                        修正する
                    </EditButton>
                    {isPublish
                        ? openUnPublishModal && (
                              <ClosedButton onClick={openUnPublishModal}>案件の公開を停止する</ClosedButton>
                          )
                        : reOpen && <ClosedButton onClick={reOpen}>案件の公開を再開する</ClosedButton>}
                </SubtitleContainer>
            )}

            <PublicBuyerDetail
                buyer={buyer}
                areaChoices={areaChoices}
                employeeChoices={employeeChoices}
                revenueChoices={revenueChoices}
                industryChoices={industryChoices}
                isPreview
            />
        </Wrapper>
    );
};
